import Vue from "vue";

export default {
  state: {
    user: {},
    userLoaded: false
  },

  mutations: {
    SET_USER_DATA(state, data) {
      state.user = data;
    },
    SET_USER_LOADED(state, loaded) {
      state.userLoaded = loaded;
    }
  },

  actions: {
    async fetchUserData(context) {
      const {data} = await Vue.axios.get('/user/get');
      if (data.result) {
        context.commit('SET_USER_DATA', data.message);
        context.commit('SET_USER_LOADED', true);
      }
    },
    fetchUserSettings() {
      return Vue.axios.get('/settings/user');
    },
    saveUserSettings(context, data) {
      return Vue.axios.post('/settings/save', data);
    },
    saveUserPersonalData(context, data) {
      return Vue.axios.post('/users/save_promo', data, {
        headers: {'X-Requested-With': 'XMLHttpRequest'}
      });
    },
    switchToOldTheme(context, theme) {
      return Vue.axios.post('/ajax/change_theme', {'theme': theme});
    },
    downloadPersonalData(context, {gdpr1, gdpr2, gdpr3}) {
      let requestData = {};
      if (gdpr1) {
        requestData['gdpr[1]'] = '';
      }
      if (gdpr2) {
        requestData['gdpr[2]'] = '';
      }
      if (gdpr3) {
        requestData['gdpr[3]'] = '';
      }
      Vue.axios.post('/user/get_userdata?csv', requestData, {
        responseType: 'blob'
      }).then(response => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');

        fileLink.href = fileURL;
        const now = new Date();
        const suffix = now.getFullYear() + '' + (now.getMonth() + 1) + '' + now.getDate();
        fileLink.setAttribute('download', 'userdata_'+suffix+'.csv');
        document.body.appendChild(fileLink);

        fileLink.click();
        setTimeout(() => {
          fileLink.remove();
        }, 1000);
      });
    },
    getUserAvailableWorkgroups() {
      return Vue.axios.post('/user/get_available_workgroups');
    },
    upgradeLicense(context, code) {
      return Vue.axios.post('/a/license/activate', {'license_key': code});
    },
    fetch2faQRCode() {
      return Vue.axios.get('/settings/qrcode2fa');
    },
    enable2fa(context, code) {
      return Vue.axios.post('/settings/enable2fa', {code});
    },
    disable2fa() {
      return Vue.axios.post('/settings/disable2fa');
    },
    restorePassword(context, email) {
      return Vue.axios.post('/noauth/restore', {'username': email});
    },
    changePassword(context, {oldPassword, newPassword}) {
      return Vue.axios.post('/settings/change_password', {'password': oldPassword, 'new_password': newPassword});
    }
  },

  getters: {
    userData: state => {
      return state.user;
    },
    userTimeZone: state => {
      return state.user.tz ? state.user.tz : "Etc/UTC";
    },

    isUserDataLoaded: state => {
      return state.userLoaded;
    },

    isOrgAdmin: state => {
      return state.userLoaded ? state.user.is_org_admin : null;
    },
    
    isOemAdmin: state => {
      return state.userLoaded ? state.user.is_oem_admin : null
    },

    isUserInOrganisation: state => {
      return state.user.organisation !== undefined && state.user.organisation !== null;
    }
  }
}
